import components from "./components/lang.en";
import routes from "./routes/lang.en";

export default {
	"slice-apple": {
		components,
		routes,
	},
};
